import logo from "./logo.svg";
import "./App.css";
import SpyGameHost from "./game";
import PrivacyPolicy from "./policy";

function App() {
  return (
    <div className="App">
      <PrivacyPolicy />
    </div>
  );
}

export default App;
